import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom'; 

const Container = styled.div`
    max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.background};
`;

const Image = styled.img`
  max-width: 100%;
  height: auto; 
  display: block; 
  margin: 1.5em auto; 
  border: 1px solid #ddd;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.1); 
`;

const Section = styled.section`
  margin-bottom: 30px;
`;

const Heading = styled.h2`
  margin-bottom: 15px;
  text-align: center;
`;

const SubHeading = styled.h3`
  color: ${({ theme }) => theme.headerText};
  margin-top: 20px;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  margin-bottom: 10px;
  line-height: 1.6;
`;

const List = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 15px;
`;

const OrderedList = styled.ol`
  list-style-type: decimal;
  margin-left: 20px;
  margin-bottom: 15px;
`;

const ListItem = styled.li`
  margin-bottom: 5px;
`;

const Strong = styled.strong`
  font-weight: bold;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  margin-bottom: 30px;
`;

const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const LinkList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-left: 20px;
  margin-bottom: 15px;

  a{
  color: ${({ theme }) => theme.headerText };}
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

// Reusing your TemplateFieldsTable component as it's perfectly generic for this use
const TemplateFieldsTable = ({ title, fields }) => (
  <Section>
    <SubHeading>{title}</SubHeading>
    <Table>
      <thead>
        <tr>
          <Th>Column #</Th>
          <Th>Column Not Used</Th>
          <Th>Target Field Category</Th>
          <Th>Target Column Name</Th>
          <Th>Target Column Type</Th>
          <Th>Classify Field Setup</Th>
          <Th>Source Column Name</Th>
        </tr>
      </thead>
      <tbody>
        {fields.map((field, index) => (
          <tr key={index}>
            <Td>{field.column_number}</Td>
            <Td>{field.column_not_used}</Td>
            <Td>{field.target_field_category}</Td>
            <Td>{field.target_column_name}</Td>
            <Td>{field.target_column_type}</Td>
            <Td>{field.target_column_classify_field_setup}</Td>
            <Td>{field.source_column_name}</Td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Section>
);

const Fhms2019Content = () => {
  const coreTemplateFields = [
    {
      column_number: 1,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_id',
    },
    {
      column_number: 2,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_main_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'feedlot_code',
    },
    {
      column_number: 3,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_record_group_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_record_group_id',
    },
    {
      column_number: 4,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_account_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_account_id',
    },
    {
      column_number: 5,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_upload_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_upload_id',
    },
    {
      column_number: 6,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_template_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_template_id',
    },
    {
      column_number: 7,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_production_lot_code',
      target_column_type: 'varchar(128)',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'production_lot_code',
    },
    {
      column_number: 8,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_sex_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'sex',
    },
    {
      column_number: 9,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_animal_age_category_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'calf_or_yearling',
    },
    {
      column_number: 10,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_percent_calves',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'age_mixed_pct_calves',
    },
    {
      column_number: 11,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_percent_yearlings',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'age_mixed_pct_yearlings',
    },
    {
      column_number: 12,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_origin_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'origin',
    },
    {
      column_number: 13,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_brd_risk_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'brd_risk',
    },
    {
      column_number: 14,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_n_animals_in',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'animals_in',
    },
    {
      column_number: 15,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_avg_date_in',
      target_column_type: 'date',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'average_date_in',
    },
    {
      column_number: 16,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_weight_in_units_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'csb_pl_source_weight_in_units_id',
    },
    {
      column_number: 17,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_weight_in_value',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_source_weight_in_value',
    },
    {
      column_number: 18,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_avg_weight_in_kgs',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
      source_column_name: 'average_weight_in_kg',
    },
    {
      column_number: 19,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_avg_date_out',
      target_column_type: 'date',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'average_date_out',
    },
    {
      column_number: 20,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_quarter_of_year_closeout_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'quarter_of_close_out',
    },
    {
      column_number: 21,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_weight_out_units_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'csb_pl_source_weight_out_units_id',
    },
    {
      column_number: 22,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_weight_out_value',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_source_weight_out_value',
    },
    {
      column_number: 23,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_avg_weight_out_kgs',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Multiple Target Fields (3)',
      source_column_name: 'average_weight_out_kg',
    },
    {
      column_number: 24,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_n_animals_dead',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'animals_dead',
    },
    {
      column_number: 25,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_n_animals_slaughtered',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'animals_slaughtered',
    },
    {
      column_number: 26,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_total_days_on_feed',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'average_days_on_feed',
    },
    {
      column_number: 27,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_total_head_days',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'head_days',
    },
  ];

  const bolusDrugTemplateFields = [
    {
      column_number: 1,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_drug_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'pen_id',
    },
    {
      column_number: 2,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_id',
    },
    {
      column_number: 3,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_main_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_main_id',
    },
    {
      column_number: 4,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_record_group_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_record_group_id',
    },
    {
      column_number: 5,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_account_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_account_id',
    },
    {
      column_number: 6,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_upload_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_upload_id',
    },
    {
      column_number: 7,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_template_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_template_id',
    },
    {
      column_number: 8,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_ordinal',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_drug_ordinal',
    },
    {
      column_number: 9,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_route_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'route_of_admin',
    },
    {
      column_number: 10,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_name',
      target_column_type: 'varchar(192)',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'active_ingredient',
    },
    {
      column_number: 11,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_value',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'total_quantity_of_antimicrobial_used_in_mg',
    },
    {
      column_number: 12,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_value_units_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'total_quantity_of_antimicrobial_units',
    },
    {
      column_number: 13,
      column_not_used: 'Used (0)',
      target_field_category: 'Trade Name (2)',
      target_column_name: 'csb_pl_drug_trade_name_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'product_name',
    },
    {
      column_number: 14,
      column_not_used: 'Used (0)',
      target_field_category: 'Active Ingredient (1)',
      target_column_name: 'csb_pl_drug_active_ingredient_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'active_ingredient',
    },
    {
      column_number: 15,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_total_mg',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'total_quantity_of_antimicrobial_used_in_mg',
    },
    {
      column_number: 16,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_total_ml',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_drug_total_ml',
    },
    {
      column_number: 17,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_primary_reason_for_use',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'reason_for_use',
    },
    {
      column_number: 18,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_respiratory',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 19,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_digestive',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 20,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_lameness',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 21,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 22,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 23,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      target_column_type: 'varchar(128)',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
  ];

  const feedDrugTemplateFields = [
    {
      column_number: 1,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_drug_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'lot_id',
    },
    {
      column_number: 2,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_id',
    },
    {
      column_number: 3,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_main_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_main_id',
    },
    {
      column_number: 4,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_record_group_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_record_group_id',
    },
    {
      column_number: 5,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_account_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_account_id',
    },
    {
      column_number: 6,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_upload_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_upload_id',
    },
    {
      column_number: 7,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_template_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_template_id',
    },
    {
      column_number: 8,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_ordinal',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_drug_ordinal',
    },
    {
      column_number: 9,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_route_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'route_of_admin',
    },
    {
      column_number: 10,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_name',
      target_column_type: 'varchar(192)',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'active_ingredient',
    },
    {
      column_number: 11,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_value',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'total_quantity_of_antimicrobial_ingredient_used_in_g',
    },
    {
      column_number: 12,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_value_units_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'total_quantity_of_antimicrobial_units',
    },
    {
      column_number: 13,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Trade Name (2)',
      target_column_name: 'csb_pl_drug_trade_name_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_drug_trade_name_id',
    },
    {
      column_number: 14,
      column_not_used: 'Used (0)',
      target_field_category: 'Active Ingredient (1)',
      target_column_name: 'csb_pl_drug_active_ingredient_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'active_ingredient',
    },
    {
      column_number: 15,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_total_mg',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'total_quantity_of_antimicrobial_ingredient_used_in_g',
    },
    {
      column_number: 16,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_total_ml',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_drug_total_ml',
    },
    {
      column_number: 17,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_primary_reason_for_use',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'reason_for_use',
    },
    {
      column_number: 18,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_respiratory',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antmicrobial_used_for', // Note: Typo 'antmicrobial' here in source data
    },
    {
      column_number: 19,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_digestive',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antmicrobial_used_for',
    },
    {
      column_number: 20,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_lameness',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antmicrobial_used_for',
    },
    {
      column_number: 21,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antmicrobial_used_for',
    },
    {
      column_number: 22,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antmicrobial_used_for',
    },
    {
      column_number: 23,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      target_column_type: 'varchar(128)',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antmicrobial_used_for',
    },
  ];

  const injectableDrugTemplateFields = [
    {
      column_number: 1,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_drug_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'lot_id',
    },
    {
      column_number: 2,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_id',
    },
    {
      column_number: 3,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_main_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_main_id',
    },
    {
      column_number: 4,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_record_group_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_record_group_id',
    },
    {
      column_number: 5,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_account_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_account_id',
    },
    {
      column_number: 6,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_survey_production_lot_upload_id',
      target_column_type: 'bigint',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_survey_production_lot_upload_id',
    },
    {
      column_number: 7,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_template_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_template_id',
    },
    {
      column_number: 8,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_ordinal',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_drug_ordinal',
    },
    {
      column_number: 9,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_route_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'route_of_admin',
    },
    {
      column_number: 10,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_name',
      target_column_type: 'varchar(192)',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'active_ingredient',
    },
    {
      column_number: 11,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_value',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'total_quantity_of_antimicrobial_used_in_ml',
    },
    {
      column_number: 12,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_source_drug_value_units_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'total_quantity_of_antimicrobial_units',
    },
    {
      column_number: 13,
      column_not_used: 'Not Used (1)', // Changed from 'Used (0)' as per FHMS structure
      target_field_category: 'Trade Name (2)',
      target_column_name: 'csb_pl_drug_trade_name_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'product_names', // Plural 'product_names' here, check consistency
    },
    {
      column_number: 14,
      column_not_used: 'Used (0)',
      target_field_category: 'Active Ingredient (1)',
      target_column_name: 'csb_pl_drug_active_ingredient_id',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'active_ingredient',
    },
    {
      column_number: 15,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_total_mg',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'csb_pl_drug_total_mg',
    },
    {
      column_number: 16,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_total_ml',
      target_column_type: 'numeric',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'total_quantity_of_antimicrobial_used_in_ml',
    },
    {
      column_number: 17,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_primary_reason_for_use',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Lookup Field (2)',
      source_column_name: 'reason_for_use',
    },
    {
      column_number: 18,
      column_not_used: 'Used (0)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_respiratory',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 19,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_digestive',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 20,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_lameness',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 21,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_neurologic',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 22,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed',
      target_column_type: 'integer',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
    {
      column_number: 23,
      column_not_used: 'Not Used (1)',
      target_field_category: 'Core Field (0)',
      target_column_name: 'csb_pl_drug_secondary_reason_mixed_description',
      target_column_type: 'varchar(128)',
      target_column_classify_field_setup: 'Setup Standard Field (1)',
      source_column_name: 'condition_antimicrobial_used_for',
    },
  ];


  return (
    <Container>
      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Feedlot Health Management Services (FHMS)
        </Heading>
        <Paragraph><Strong>Site Information Details</Strong></Paragraph>
        <Paragraph>Feedlot Health Management Services (4) (FHMS)</Paragraph>
        <Paragraph>Vet: CSBV00001 (1)</Paragraph>
        <Paragraph>Project Year: 2019</Paragraph>
        <Paragraph>The site has eight (8) herds. The herds used for this project year are:</Paragraph>
        <List>
          <ListItem>CSBH000001</ListItem>
          <ListItem>CSBH000002</ListItem>
          <ListItem>CSBH000003</ListItem>
          <ListItem>CSBH000004</ListItem>
          <ListItem>CSBH000005</ListItem>
          <ListItem>CSBH000006</ListItem>
          <ListItem>CSBH000007</ListItem>
          <ListItem>CSBH000008</ListItem>
        </List>

        <Paragraph>Access to current years documentation click on the appropriate link below:</Paragraph>
        <LinkList>
          <ListItem><Link to="/beef/data-preparation/fhms2020">FHMS 2020</Link></ListItem>
          <ListItem><Link to="/beef/data-preparation/fhms2021">FHMS 2021</Link></ListItem>
          <ListItem><Link to="/beef/data-preparation/fhms2022">FHMS 2022</Link></ListItem>
          <ListItem><Link to="/beef/data-preparation/fhms2023">FHMS 2023</Link></ListItem>
          <ListItem><Link to="/beef/data-preparation/fhms2024">FHMS 2024</Link></ListItem>
        </LinkList>

        <Paragraph>Up to now we upload 1 year's data for 1 herd.</Paragraph>
        <Paragraph><Strong>FHMS has a different data source structure.</Strong></Paragraph>
        <Paragraph>All core production lot data, for all herds are in a single worksheet and no drug data is included.</Paragraph>
        <Paragraph>In the application, for previous uploads, I would add a survey record to include the year and its herd.</Paragraph>
        <Paragraph>At that point we could add the herd's core and associated drug data.</Paragraph>

        <Paragraph><Strong>For FHMS data we need to make sure we have added all survey records for a year for all herds.</Strong></Paragraph>
        <Paragraph>The upload process will upload data for all herds at once, not just one herd at a time.</Paragraph>

        <Paragraph>You can check within the source worksheet of core field production lot data for available herds in the data.</Paragraph>
        <Paragraph>To do this copy all the data in the column referring to the survey herd codes.</Paragraph>
        <Paragraph>Next, in a new worksheet, paste the column of herd codes. There are many repeated herd codes.</Paragraph>
        <Paragraph>To see just the unique herd codes, highlight the column of herd codes within the worksheet, click on the menu-item Data, then click on button to "<Strong>Remove Duplicates</Strong>".</Paragraph>
        <Paragraph>You will see the unique herd codes provided the site.</Paragraph>
      </Section>

      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Feedlot Health Management Services (FHMS)
          <br />
          Data Source Information
        </Heading>
        <Paragraph>FHMS has 8 herds.</Paragraph>
        <Paragraph>Each spreadsheet within a workbook from FHMS represents all herds for a specific sampling year.</Paragraph>
        <Paragraph>The core production lot fields resides in 1 worksheet within the workbook.</Paragraph>
        <Paragraph>The drug information for bolus fields resides in a worksheet within the workbook.</Paragraph>
        <Paragraph>The drug information for feed fields resides in a worksheet within the workbook.</Paragraph>
        <Paragraph>The drug information for injectable fields resides in a worksheet within the workbook.</Paragraph>
        <Paragraph><Strong>Because of this we need to upload all 4 worksheets before we attempt to integrate the data into production.</Strong></Paragraph>
        <Paragraph>Each worksheet will be checked separately against its corresponding template.</Paragraph>
        <Paragraph>Once checking is completed and all seems well, then we integrate the data.</Paragraph>
        <Paragraph>All 4 uploaded datasets are necessary before the integrations step can take place within the application.</Paragraph>

        <Paragraph>The core data when uploaded will be set to be uploaded as columns and drugs set to be mixed.</Paragraph>
        <Paragraph>In actual fact there is no drug data in the core worksheet. It will upload in this format with no problem.</Paragraph>
        <Paragraph><Strong>The drugs are listed as rows, not columns, within the sheet.</Strong></Paragraph>
        <Paragraph>The drugs are set to its specific drug route when being uploaded i.e. Bolus, Feed or Injectable. No need to choose mixed!</Paragraph>

        <Paragraph>Core field data has no drug data in the worksheet.</Paragraph>
        <Paragraph>However, as mentioned above, all herds for FHMS for a specific year are available.</Paragraph>
        <Paragraph><Strong>Because of this, make sure you have created a survey record for each herd for the year you are uploading and integrating.</Strong></Paragraph>
        <Paragraph>If it is not done, then we have no way to associate the production lot data with a survey!</Paragraph>
        <Paragraph>During the upload of the spreadsheet into the database, missing or implied core field data is filled in.</Paragraph>
        <Paragraph>The rows of drug data represent 1 drug, usually a product name and active ingredient for 1 drug route.</Paragraph>
        <Paragraph>All drug routes and associated drugs for a production lot are available within the three remaining drug worksheets.</Paragraph>
      </Section>

      <Section>
        <SubHeading>Extra Data Preparation Steps in the Spreadsheet</SubHeading>
        <OrderedList>
          <ListItem>
            <Paragraph>The season or "Quarter Closeout" field is available.</Paragraph>
            <Paragraph>The seasons are defined in the following way:</Paragraph>
            <List>
              <ListItem><Strong>Winter</Strong> &rarr; January 1 thru March 31</ListItem>
              <ListItem><Strong>Spring</Strong> &rarr; April 1 thru June 30</ListItem>
              <ListItem><Strong>Summer</Strong> &rarr; July 1 thru September 30</ListItem>
              <ListItem><Strong>Fall</Strong> &rarr; October 1 thru December 31</ListItem>
            </List>
          </ListItem>
          <ListItem>
            <Paragraph><Strong>Before creating and setting up a template, go through all spreadsheets provided from the site.</Strong></Paragraph>
            <Paragraph>Collect field names from each site and put them together. Review the field names to make sure they all match. My experience is the field names do not match. To reduce the number of templates to create, get the field names to match. The fields do not need to be in the same order.</Paragraph>
          </ListItem>
          <ListItem>
            <Paragraph><Strong>The drug data to be uploaded requires a column to be added by the data preparation people.</Strong></Paragraph>
            <Paragraph>The column added is "Total quantity of antimicrobial units" for the bolus, feed and injectable worksheets.</Paragraph>
            <Paragraph>Each new column has a parent column we use as a guide for the values to insert into the appropriate worksheet.</Paragraph>
            <List>
              <ListItem>For Bolus, the parent column is "Total quantity of antimicrobial used in mg". In the new empty column inserted right beside this column add the value "mg" for all bolus records.</ListItem>
              <ListItem>A similar process is used for the feed and injectable worksheets (e.g., 'g' for feed, 'ml' for injectable).</ListItem>
            </List>
          </ListItem>
        </OrderedList>
      </Section>

      <Section>
        <Heading>
          Production Lot Upload Data Preparation: Feedlot Health Management Services (FHMS)
          <br />
          Template Setup Suggestions
        </Heading>
        <Paragraph>A <Strong>four template setup</Strong> is used for one or more years batch of data.</Paragraph>
        <Paragraph>For the current document, we assume place all known drug fields for each drug route resides in a separate specific drug data worksheet.</Paragraph>
        <Paragraph>No data switches from core field columns to drug fields as rows for the setup of data for this site!</Paragraph>

        <Paragraph><Strong>Four templates are created.</Strong> The primary, top level template created represents the Core fields.</Paragraph>
        <Paragraph>The secondary, second level child template created represents the Drug fields associated with a Core row of data.</Paragraph>
        <Paragraph>One drug template is required for each drug route, you need to create separate templates for each drug route.</Paragraph>

        <Paragraph>The Core Template is populated from the Target Table from the production lot table (core fields).</Paragraph>
        <Paragraph>The Child Drug Template is populated from the Target Table from the drug table.</Paragraph>

        <Paragraph>When setting up the core template, make sure a field is specified in the worksheet of core data to match the <Strong><code>csb_survey_main_id</code></Strong> target field. In this way I can find the correct main id based on herd code.</Paragraph>
        <Paragraph>When setting up each drug template, make sure a field is specified in the worksheet of drug data to match the <Strong>production lot code source field name</Strong>. I use the unused field <Strong><code>csb_survey_production_lot_drug_id</code></Strong> target field. In this way the production lot code field name is identified.</Paragraph>

        <Paragraph>Here are the typical template settings used for FHMS.</Paragraph>
      </Section>
      <SubHeading as="h4">Name: FHMS 2019 - Core</SubHeading>
        <List>
          <ListItem><Strong>Level:</Strong> Top Level (1)</ListItem>
          <ListItem><Strong>Type:</Strong> Core </ListItem>
          <ListItem><Strong>Route:</Strong> Multiple Drugs</ListItem>
          <ListItem><Strong>Version:</Strong> Version 1 (1)</ListItem>
          <ListItem><Strong>By Row or Column:</Strong> By Column </ListItem>
          <ListItem><Strong>Method:</Strong> Populate template fields from Target (1)</ListItem>
        </List>
        <Image src="/images/ss_template_fhms_core_2019.png"/>
      <TemplateFieldsTable
        title="Core Template: Associated Core Template Fields"
        fields={coreTemplateFields}
      />

      <Section>
        <SubHeading>Drug Templates (General Settings)</SubHeading>
        <List>
          <ListItem><Strong>Name:</Strong> FHMS 2019 - Drugs</ListItem>
          <ListItem><Strong>Level:</Strong> Second Level</ListItem>
          <ListItem><Strong>Type:</Strong> Drug</ListItem>
          <ListItem><Strong>Route:</Strong> Bolus</ListItem>
          <ListItem><Strong>Version:</Strong> Version 1</ListItem>
          <ListItem><Strong>By Row or Column:</Strong> By Row</ListItem>
          <ListItem><Strong>Method:</Strong> Populate template fields from Target</ListItem>
        </List>
        <Image src="/images/ss_template_fhms_drug_bolus.png"/>
        <Paragraph>Remember: You will create three separate templates with these general settings, one for each drug route: Bolus, Feed, and Injectable, with their specific field mappings.</Paragraph>
      </Section>
      <TemplateFieldsTable
        title="Bolus Drug Template: Associated Drug Template Fields"
        fields={bolusDrugTemplateFields}
      />


       <Image src="/images/ss_template_fhms_drug_feed.png"/>
      <TemplateFieldsTable
        title="Feed Drug Template: Associated Drug Template Fields"
        fields={feedDrugTemplateFields}
      />


       <Image src="/images/ss_template_fhms_drug_injectable.png"/>
      <TemplateFieldsTable
        title="Injectable Drug Template: Associated Drug Template Fields"
        fields={injectableDrugTemplateFields}
      />

      <Section>
        <SubHeading>Upload Process Summary</SubHeading>
        <OrderedList>
          <ListItem>The core data when uploaded will be set to be uploaded as <Strong>columns</Strong> and drugs set to be mixed (though no drug data is in the core sheet, it won't cause issues).</ListItem>
          <ListItem>The drugs are set to their specific drug route when being uploaded (i.e., Bolus, Feed, or Injectable). <Strong>No need to choose "mixed" for drug uploads.</Strong></ListItem>
          <ListItem>All 4 worksheets must be uploaded <Strong>before</Strong> attempting to integrate the data into production. Each worksheet is checked separately against its corresponding template.</ListItem>
          <ListItem>All 4 uploaded datasets are necessary before the integration step can take place within the application.</ListItem>
        </OrderedList>
      </Section>
    </Container>
  );
};

export default Fhms2019Content;